import { useEffect, useMemo, useState } from 'react';
import { buildTocFromContent } from '@/utils/glossary-toc';

const GlossaryTableOfContents = ({ content, title = 'Obsah stránky' }) => {
  const items = useMemo(() => buildTocFromContent(content), [content]);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    if (items.length === 0 || typeof window === 'undefined') return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);

        if (visible.length > 0) {
          setActiveId(visible[0].target.id);
        }
      },
      {
        rootMargin: '-20% 0px -60% 0px',
        threshold: [0, 0.25, 0.5, 1]
      }
    );

    const elements = items.map((item) => document.getElementById(item.id)).filter((element) => element !== null);

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [items]);

  if (items.length === 0) {
    return null;
  }

  return (
    <nav aria-label={title} className="bg-grey-50 rounded-2xl px-6 py-5">
      <div className="text-grey-500 mb-3 text-xs font-bold tracking-[0.08em] uppercase">{title}</div>
      <ul className="flex flex-col gap-1">
        {items.map((item) => {
          const isActive = activeId === item.id;

          return (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`block py-1 text-sm transition-colors ${
                  isActive ? 'text-brand-500 font-semibold' : 'text-grey-600 hover:text-grey-900'
                } ${item.level === 3 ? 'pl-3' : ''}`.trim()}
              >
                {item.label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default GlossaryTableOfContents;
